import { Suspense, lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useSpaceViewPageSetup } from '../hooks/useSpaceViewPageSetup'
import { ViewLoadingFallback } from '@/routes/features/projects/components/ViewLoadingFallback'
import { ProjectViewControls } from '@/routes/features/projects/components/ProjectViewControls'
import { FilterBar } from '@/components/features/filters'
import { Loading } from '@/components/app/indicators/Loading'

const ProjectCalendarView = lazy(() =>
  import('@/routes/features/projects/components/ProjectCalendarView').then((m) => ({
    default: m.ProjectCalendarView,
  })),
)

export const Route = createFileRoute(
  '/_AppWrapper/_AppLayout/$workspaceSlug/spaces/$spaceKey/calendar',
)({
  component: SpaceCalendarViewPage,
})

function SpaceCalendarViewPage() {
  const { workspaceSlug, spaceKey } = Route.useParams()
  const { space, spaceLoading, topLevelTasks, isLoading, density } =
    useSpaceViewPageSetup(workspaceSlug, spaceKey, (spaceId) => (
      <ProjectViewControls
        projectId={spaceId}
        scope="space"
        pinnedFields={['project']}
      />
    ))

  if (spaceLoading) {
    return (
      <div className="flex min-h-full flex-1 items-center justify-center">
        <Loading />
      </div>
    )
  }

  if (!space) return null

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex-shrink-0">
        <FilterBar projectId={space.id} pinnedFields={['project']} scope="space" />
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Suspense fallback={<ViewLoadingFallback />}>
          <ProjectCalendarView
            projectId={space.id}
            density={density}
            tasks={topLevelTasks}
            isLoading={isLoading}
          />
        </Suspense>
      </div>
    </div>
  )
}
